import React from 'react';
import styled, { keyframes } from 'styled-components';
import tw from 'tailwind.macro';

const loopAnimation = keyframes`
0% {
  transform: translateX(0);
}
100% {
  transform: translateX(-50%);
}
`;

interface SliderProps {
  durationInSec: number;
  direction: 'reverse' | 'normal';
  stop?: boolean;
}

const Slider = styled.div<SliderProps>`
  ${tw`flex`}
  gap: 24px;
  width: fit-content;

  animation-name: ${loopAnimation};
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: ${({ direction }) => direction};
  animation-duration: ${({ durationInSec }) => durationInSec}ms;
  animation-play-state: ${({ stop }) => (stop ? 'paused' : 'running')};

  &:hover {
    animation-play-state: paused;
  }
`;

interface InfiniteSliderProps {
  children?: React.ReactNode;
  durationInSec: number;
  reverse?: boolean;
  stop?: boolean;
  removeDuplicates?: boolean;
}

const InfiniteSlider: React.FC<InfiniteSliderProps> = ({
  children,
  durationInSec,
  removeDuplicates,
  reverse = false,
  stop,
}) => {
  return (
    <div style={{ margin: 'auto' }}>
      <Slider
        direction={reverse ? 'reverse' : 'normal'}
        durationInSec={durationInSec}
        stop={stop}
      >
        {children}
        {removeDuplicates ? null : children}
      </Slider>
    </div>
  );
};

export { InfiniteSlider };
